export default {
    arrayBufferToBase64 (response) {
        let image = btoa(
            new Uint8Array(response.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ''
            )
        )

        return `data:${response.headers['content-type'].toLowerCase()};base64,${image}`
    }
}